/* eslint-disable react/prop-types */
// External deps

import { Table, ContentCard } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

// Internal deps
import './NotificationReportAnexo.scss';
// import mockData from '../mockData';
import { formatDate } from '../../../utils/formatUtils';
import useToast from '../../../hooks/useToast';

const NotificationReportAnexo = ({ data }) => {
  const { setNewToast } = useToast();

  const download = async (link, nombre) => {
    try {
      setNewToast({
        type: 'INFO',
        message: 'Descargando, por favor espere.'
      });

      const extensionCanOpenInBrowser = ['.pdf', '.jpg', '.jpeg', '.png'];
      const canVisualize = nombre
        ? extensionCanOpenInBrowser.some((ext) => nombre.toLowerCase().includes(ext.toLowerCase()))
        : false;

      if (canVisualize) {
        window.open(link, '_blank');
      } else {
        const a = document.createElement('a');

        a.href = link;
        a.setAttribute('download', nombre);
        document.body.appendChild(a);
        a.click();
      }
    } catch (e) {
      setNewToast({
        type: 'ERROR',
        message: 'No se pudo descargar el archivo.'
      });
    }
  };

  const reporteColumns = [
    {
      Header: 'SDS',
      accessor: 'numeroSolicitud',
      hideSort: true,
      style: {
        width: '30%'
      },
      Cell: ({ value }) => <span className="table-cell">{value}</span>
    },
    {
      Header: 'Fecha',
      accessor: 'fechaSubida',
      hideSort: true,
      style: {
        width: '30%'
      },
      Cell: ({ value }) => <span className="table-cell">{formatDate({ value })}</span>
    },
    {
      Header: 'Link',
      accessor: 'nombre',
      hideSort: true,
      style: {
        width: '30%'
      },
      Cell: ({ row, value }) => (
        <div
          className="table-links"
          onClick={() => download(row.original.linkDeDescarga, value)}
          onKeyDown={() => download(row.original.linkDeDescarga, value)}
          role="button"
          tabIndex={0}
        >
          <span className="table-cell">{value}</span>
        </div>
      )
    }
  ];

  return (
    <>
      <ContentCard className="mb-4" mark="none" orientation="vertical">
        <h6 className="table-title">Anexos</h6>
        <Table
          columns={reporteColumns}
          data={data.reporteDeAnexos}
          // data={mockData.reporteDeAnexos}
          titleLeft
          type="light"
        />
      </ContentCard>
    </>
  );
};

NotificationReportAnexo.propTypes = {
  data: PropTypes.shape({
    reporteDeAnexos: PropTypes.shape([
      {
        idArchivoAdjuntoParteDiario: PropTypes.number,
        idParteTrabajoDiario: PropTypes.number,
        nombre: PropTypes.string,
        fechaSubida: PropTypes.string,
        numeroSolicitud: PropTypes.string
      }
    ])
  })
};
NotificationReportAnexo.defaultProps = {
  data: {}
};

export default NotificationReportAnexo;
